import { useState, useEffect } from 'react';
import { AgGridReact, AgGridColumn } from 'ag-grid-react';
import styled from 'styled-components';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import moment from 'moment'

// Tool Panel 
import Presets from '../../components/Grid/Presets/Presets';
import { excelStyles } from '../../components/Grid/ExcelStyles/excelStyles';
import { LicenseManager } from 'ag-grid-enterprise';
import TotalRow from '../../components/Grid/CellRenderer/TotalRow';
LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID);

const CommercialProductsGrid = ({
  commercialProductsList,
  search,
  triggerExport,
  setTriggerExport,
  onDeleteClicked,
  onRowClicked,
}) => {
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [rowData, setRowData] = useState(commercialProductsList);
  const [totalRows, setTotalRows] = useState(commercialProductsList ? commercialProductsList.length : 0);

  useEffect(() => {
    if(commercialProductsList){
      setTotalRows(commercialProductsList.length)
    }
  }, [commercialProductsList]);

  useEffect(() => {
    if (gridApi) {
      if(search) {
        gridApi.setQuickFilter(search);
      } else {
        gridApi.setQuickFilter("");
      }
    }
  }, [search]);

  useEffect(() => {
    setRowData(commercialProductsList)
  }, [commercialProductsList]);

  useEffect(() => {
    if(triggerExport === true) {
      onBtnExport()
      setTriggerExport(false);
    }
  }, [triggerExport])

  const deleteRow = (itemId) => {
    onDeleteClicked(itemId);
  }

  const onFilterChanged = () => {
    if (gridApi) {
      const displayedRowCount = gridApi.getDisplayedRowCount();
      setTotalRows(displayedRowCount);
    }
  };

  const cellClicked = (event) => {
    const { cellRenderer } = event.colDef;
    if (cellRenderer !== "removeRow") {
      onRowClicked(event.data);
    }
  };

  const gridOptions = {
    columnDefs: [
      {
        headerName: 'Name',
        field: 'name',
        flex: '2'
      },
      {
        headerName: "",
        width: 40,
        cellRenderer: "removeRow",
      }
    ],
    defaultColDef: {
      resizable: true,
      sortable: true,
      wrapText: true,
      filter: true,
      enablePivot: true,
      enableCharts: false,
      enableRowGroup: true,
      filterParams: {
        clearButton: true
      },
      cellStyle: { "white-space": "normal !important" },
      autoHeight: true,
      cellClassRules: {
        oddBackground: function (params) {
          return params.rowIndex % 2 == 0;
        },
      },
    },
    icons: {
      list: '<i className="fal fa-list"></i>'
    },
    columnTypes:{
      date: {
        filter: 'agDateColumnFilter',
        filterParams: {
          resetButton: true,
          comparator: function(filterLocalDateAtMidnight, cellValue) {
            let cellDate = null;
            let dateAsString = "";
            dateAsString = cellValue;
            if (dateAsString === null) {
              return 0;
            }
            cellDate = moment(dateAsString).toDate();
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            } else if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            } else {
              return 0;
            }
          }
        }
      }
    },
    excelStyles,
    frameworkComponents: {
      removeRow: ({ data }) => {
        return (
          <i
            className="fal fa-trash-alt"
            style={{ color: "red" }}
            onClick={() => deleteRow(data)}
          ></i>
        );
      },
    }
  }

  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  }

  const onBtnExport = () => {
    const params = {
      fileName: "study_list",
      columnKeys: [
        "study_id",
        "sites_count",
        "nct_id"
      ],
      headerRowHeight: 25,
      rowHeight: 20,
    }
    gridApi.exportDataAsExcel(params)
  };

  return (
    <Container className="ag-theme-balham">
      <AgGridReact
        onGridReady={onGridReady}
        gridOptions={gridOptions}
        rowData={rowData}
        onCellClicked={event => cellClicked(event)}
        onFilterChanged={onFilterChanged}
        >

      </AgGridReact>
      <TotalRow count={totalRows} />
    </Container>
  );
};

export default CommercialProductsGrid;

const Container = styled.div`
flex: 1 1 auto;
padding-bottom: 20px;
`